import './App.scss';
import React from 'react';


function App() {

  return (
    <div>
      <h1 className="visually-hidden">crlacayo</h1>
      <p>Howdy and welcome to my personal homepage. My name is Carlos and I am a full stack developer* and content creator. In the meantime, here are my current projects that I am working on:</p>
        <ul>
          <li><a href="https://www.youtube.com/houexplorer" target="_blank" title="HOUExplorer YouTube Site" rel="noopener noreferrer">HOUExplorer's YouTube site</a>: Exploring public transit in a point of view perspective.</li>
          <li><a href="https://www.houexplorer.com/" target="_blank" title="HOUExplorer website" rel="noopener noreferrer">HOUExplorer Blog Site</a>: A blog site that company's the HOUExplorer's channel.</li>
          <li><a href="https://www.transitdata.live/" target="_blank" title="transitdata.live web application" rel="noopener noreferrer">transitData.live</a>: View live buses and trains on the map.</li>
        </ul>
        <hr/>
        <h2>* Full Stack Developer <i className="bi bi-tools"></i></h2>
        <p>I mainly work with Microsoft technologies (and React). Here are some tech stuff that I have (and currently) work on:</p>
        <ul>
          <li>Microsoft Power Platform (Power Automate, Power Apps, and Dataverse-SharePoint/Dynamics CRM)</li>
          <li>ASP.NET and .NET CORE</li>
          <li>T-SQL</li>
          <li>Azure (managing cloud infastracture, such as Iaas and PaaS).</li>
          <li>JavaScript</li>
          <li>TypeScript</li>
          <li>SCSS/SASS/CSS</li>
          <li>React (for web)</li>
        </ul>
        <hr/>
        <h2>Questions or comments <i className="bi bi-envelope-fill"></i></h2>
        <p>If you have questions or comments, please send me an email at: <a href="mailto:info@crlacayo.com" title="Email me and I shall respond.">info@crlacayo.com</a>.</p>
      </div>
  );
}

export default App;
